<template>
  <div class="p-12 w-full">
    <section class="space-y-8">
      <header class="space-y-2">
        <BaseButton small primary outline @click="$emit('back')">Back</BaseButton>
        <h3 class="text-lg font-medium">Membership products</h3>
      </header>
      <BaseDataIterator :service="fetchData" disable-filters>
        <!-- props
          data, fetchList
        -->
        <template #default="dataIteratorProps">
          <BaseGrid :columns="4" class="p-4 bg-gray-100">
            <BaseCard v-for="product in dataIteratorProps.data" :key="product.id">
              <BaseCardBody>
                <h5 class="text-base font-medium">{{ product.name }}</h5>
                <div class="mt-10 flex justify-end">
                  <BaseButton primary outline block @click="handleSelectProduct(product)"
                    >Select</BaseButton
                  >
                </div>
              </BaseCardBody>
            </BaseCard>
          </BaseGrid>
        </template>
      </BaseDataIterator>
    </section>
  </div>
</template>

<script>
import { productsClient } from '@/api/clients';
import { merge } from 'lodash-es';

export default {
  data() {
    return {
      query: {
        filter: {
          type: 'membership',
        },
        include: ['media'],
      },
    };
  },
  methods: {
    fetchData(query = {}) {
      return productsClient.list(merge(query, this.query));
    },
    handleSelectProduct(product) {
      this.$emit('select', product);
    },
  },
};
</script>
